document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-header]');
  const menuButton = document.querySelector('[data-mobile-menu-button]');
  const menu = document.getElementById('MobileMenu');

  const syncHeader = () => {
    if (!header) return;
    header.dataset.scrolled = window.scrollY > 20 ? 'true' : 'false';
  };
  syncHeader();
  window.addEventListener('scroll', syncHeader, {passive:true});

  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });
    menu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
      menu.hidden = true;
      menuButton.setAttribute('aria-expanded', 'false');
    }));
  }

  // Resolve selected product options to the correct Shopify variant.
  const productJson = document.querySelector('[data-product-json]');
  const productSection = document.querySelector('[data-product-section]');
  if (productJson && productSection) {
    try {
      const product = JSON.parse(productJson.textContent);
      const form = productSection.querySelector('form[action*="/cart/add"]');
      const variantId = form?.querySelector('[data-variant-id]');
      const selects = [...productSection.querySelectorAll('[data-option-index]')];
      const price = productSection.querySelector('[data-product-price]');
      const addButton = productSection.querySelector('[data-add-button]');
      const moneyFormat = (window.Shopify && Shopify.money_format) || null;
      const formatMoney = (cents) => {
        if (moneyFormat && window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, moneyFormat);
        return (cents / 100).toFixed(2);
      };
      const syncVariant = () => {
        if (!selects.length) return;
        const values = selects.map(s => s.value);
        const variant = product.variants.find(v => v.options.every((v,i) => v === values[i]));
        if (!variant) {
          if (variantId) variantId.value = '';
          if (addButton) { addButton.disabled = true; addButton.textContent = 'UNAVAILABLE'; }
          return;
        }
        if (variantId) variantId.value = variant.id;
        if (price) price.textContent = formatMoney(variant.price);
        if (addButton) { addButton.disabled = !variant.available; addButton.textContent = variant.available ? 'ADD TO BAG' : 'SOLD OUT'; }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      };
      selects.forEach(s => s.addEventListener('change', syncVariant));
      syncVariant();
    } catch (e) { console.warn('Product variant data could not be parsed.', e); }
  }

  // AJAX add-to-cart with graceful fallback.
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    const variantInput = form.querySelector('[data-variant-id]');
    if (variantInput && !variantInput.value) return;
    event.preventDefault();
    const button = form.querySelector('[name="add"]');
    const original = button?.textContent || 'ADD TO BAG';
    if (button) { button.disabled = true; button.textContent = 'ADDING…'; }
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST', headers: {'Accept':'application/json'}, body: new FormData(form)
      });
      if (!response.ok) throw new Error('Cart add failed');
      const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then(r => r.json());
      document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
      if (button) { button.textContent = 'ADDED TO BAG'; setTimeout(() => { button.textContent = original; button.disabled = false; }, 1400); }
    } catch (e) {
      form.submit();
    }
  });
});
